var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V112H496V16Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 112H16V208H496V112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 208H16V304H496V208Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 304H16V400H496V304Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 400H16V496H496V400Z",
    fill: "#E74C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L256 256.002L16 496V16Z",
    fill: "#3498DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.862 312.053L112.243 283.415L74.3559 312.91L90.5857 270.185L50.8267 243.266L96.476 245.499L109.791 199.368L121.774 243.473L169.762 241.88L131.518 266.906L147.862 312.053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/PR.14c2abdd0a5c8f6038353a731136ffb1.svg";
export { ForwardRef as ReactComponent };